







































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { ShopItemOptionMultipleChoiceDefinition } from "@/store/states/ShopState";
import { CartState } from "@/store/states/CartState";

@Component
export default class MultipleChoiceOption extends Vue {
  @State("cart") cart: CartState;

  @Action("selectOptionFromMultipleChoice", { namespace: "cart" })
  select: Function;

  @Prop({ required: true })
  public currentOption!: ShopItemOptionMultipleChoiceDefinition;

  @Prop({ required: true })
  public onChange: Function;

  public isCurrentOptionSelected(optionUuid: string) {
    if (this.cart.current.itemOptions[this.currentOption.uuid]) {
      return this.cart.current.itemOptions[this.currentOption.uuid][optionUuid];
    } else {
      return false;
    }
  }

  public selectOption(itemOptionUuid: string, choiceUuid: string) {
    this.select({ itemOptionUuid: itemOptionUuid, choiceUuid: choiceUuid });
    this.onChange();
  }
}
